import React, { memo } from 'react';
import { ScrollContainer } from '../container/ScrollContainer';
import classNames from 'classnames';
const ModalBody = memo(({ className, children, isScroll = true, isBorder, isPadding = true, startScrollToDownDate, startScrollToTopDate, id, }) => {
    const renderContent = () => {
        const classNameResult = classNames('ac-modal-body', {
            'pt-x6': isPadding,
            'pr-x6': isPadding,
            'pb-x6': isPadding,
            'pl-x6': isPadding,
        }, {
            'ac-modal-body-border': isBorder,
        }, className);
        if (isScroll) {
            return (React.createElement(ScrollContainer, { id: id, startScrollToTopDate: startScrollToTopDate, startScrollToDownDate: startScrollToDownDate, className: classNameResult }, children));
        }
        else {
            return (React.createElement("div", { id: id, className: classNameResult }, children));
        }
    };
    return React.createElement(React.Fragment, null, renderContent());
});
export { ModalBody };
//# sourceMappingURL=ModalBody.js.map